module.exports = __webpack_public_path__ + "img/draft-marks-after.43f4fc0d.webp";